import { matchPath } from "react-router-dom";
import { KARKHANA_PAGES, KP } from "../karkhanaPaths";

/**
 * Where a Karkhana page sits, for the header trail "Karkhana › More › Rate cards › Butidar 101":
 * the pages between Karkhana Home and this one, from the route alone, so every page has it without
 * passing anything. A page can still pass its own crumbs.
 */
export type Crumb = { to: string; label: string };

const DAILY: Crumb = { to: KP.dailyWork, label: "Daily work" };
const ATTENDANCE: Crumb = { to: KP.attendance, label: "Attendance" };
const PAY: Crumb = { to: KP.pay, label: "Pay" };
const MORE: Crumb = { to: KP.more, label: "More" };

const RULES: [string[], Crumb[]][] = [
  [[KP.home, KP.dailyWork, KP.attendance, KP.pay, KP.more], []],
  [[KP.rounds, KP.loom], [DAILY]],
  [[KP.jobWork], [ATTENDANCE]],
  [[KP.paySheets, KP.cashBook], [PAY]],
  [[KP.paySheet], [PAY, { to: KP.paySheets, label: "Pay sheets" }]],
  [[KP.rateImport, KP.rateCard], [MORE, { to: KP.rateCards, label: "Rate cards" }]],
  [[KP.costing], [MORE, { to: KP.costings, label: "Costing" }]],
  [[KP.saree], [MORE, { to: KP.sarees, label: "Sarees" }]],
  [[KP.workerImport, KP.workerPhotos, KP.workerReview, KP.codes], [MORE, { to: KP.workers, label: "Workers" }]],
];

export const trailFor = (pathname: string): Crumb[] => {
  for (const [paths, crumbs] of RULES) {
    if (paths.some((path) => matchPath(pathname, { path, exact: true }))) return crumbs;
  }
  // Everything else (rate cards, designs, workers, settings, imports…) is reached from More.
  return pathname.startsWith(`${KP.home}/`) ? [MORE] : [];
};

/** This page's own name for the end of the trail ("Karkhana › Attendance"), from the route. */
export const screenFor = (pathname: string): string | undefined => {
  for (const page of KARKHANA_PAGES) {
    const path = (KP as Record<string, string>)[page.key];
    if (path && path !== KP.home && matchPath(pathname, { path, exact: true })) return page.screen;
  }
  return undefined;
};

/** Karkhana Home itself: the one page with no Back and no trail. */
export const isKarkhanaHome = (pathname: string) => !!matchPath(pathname, { path: KP.home, exact: true });
